import useAxiosAuth from "@/hooks/useAxiosAuth";
import { PaginatedProduct, Product } from "@/types";
import { DSS_ENDPOINTS } from "../dss-endpoints";

const useProductsApi = () => {
	const axios = useAxiosAuth();

	// we'll need to add pagination to this endpoint
	const fetchAllProducts = async (options?: any) => {
		const { data } = await axios.axiosNoAuth.get<PaginatedProduct>(
			DSS_ENDPOINTS.products,
			{
				params: { ...options },
			}
		);

		return data;
	};

	const fetchProductDetails = async (
		sku: string,
		options: {
			size?: string;
			colour_variant?: string;
		} | null
	) => {
		const { data } = await axios.axiosNoAuth.get<
			{ images: string[] } & Product
			// { images: string[] } & Product
		>(`${DSS_ENDPOINTS.products}/${sku}`, {
			params: { ...options },
		});

		return data;
	};

	return {
		fetchAllProducts,
		fetchProductDetails,
	};
};

export default useProductsApi;
